import { ModalTrigger } from '@fiverr-private/overlay';

export default ModalTrigger;
